import React, { useReducer } from 'react'
import NetSuiteContext from './netSuiteContext'
import NetSuiteReducer from './netSuiteReducer'
import { apiCall } from '../../../common/api'
import { response } from '../../common'

import { CLEAR_RESPONSE, RESPONSE_STATUS } from './netSuiteTypes'

const NetSuiteState = (props) => {
    const initialState = {
        responseStatus: null,
    }

    const [state, dispatch] = useReducer(NetSuiteReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getInventoryItem = async (formData) => {
        const from = 'getInventoryItem'
        try {
            const [res] = await Promise.all([
                apiCall('post', from, formData, '', 'third_party/netsuite'),
            ])

            resp.commonResponse(res.data, from)
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })
    return (
        <NetSuiteContext.Provider
            value={{
                responseStatus: state.responseStatus,
                getInventoryItem,
                clearResponse,
            }}
        >
            {props.children}
        </NetSuiteContext.Provider>
    )
}

export default NetSuiteState
